<template>
  <div id="Index">
    <jw-frame>
      <Form ref="infoForm" :model="webSitInfo" :rules="ruleValidate" label-position="left" :label-width="85" :label-colon="true">
        <FormItem label="网站名称" prop="web_sit_name">
          <Input v-model="webSitInfo.web_sit_name" placeholder="请输入网站名称"/>
        </FormItem>
        <FormItem label="联系人" prop="link_man">
          <Input v-model="webSitInfo.link_man" placeholder="请输入联系人"/>
        </FormItem>
        <FormItem label="联系电话" prop="link_phone">
          <Input v-model="webSitInfo.link_phone" placeholder="请输入联系电话"/>
        </FormItem>
        <FormItem label="联系地址" prop="address">
          <Input v-model="webSitInfo.address" placeholder="请输入联系地址"/>
        </FormItem>
        <FormItem label="版权所有" prop="copyright">
          <Input v-model="webSitInfo.copyright" placeholder="请输入版权所有"/>
        </FormItem>
        <FormItem label="备案信息" prop="icp">
          <Input v-model="webSitInfo.icp" placeholder="请输入备案信息"/>
        </FormItem>
        <FormItem label="技术支持" prop="tech">
          <Input disabled v-model="webSitInfo.tech" placeholder="请输入技术支持"/>
        </FormItem>
      </Form>
      <div style="text-align: right;">
        <Button type="primary" @click="saveAction">保 存</Button>
      </div>
    </jw-frame>
  </div>
</template>

<script>
import {getWebSitInfo, editWebSitInfo} from "@/request/websit";

export default {
  name: "Index",
  data() {
    return {
      webSitInfo: {
        web_sit_name: '',
        link_man: '',
        link_phone: '',
      },
      ruleValidate: {
        web_sit_name: [
          { required: true, message: '请输入网站名称', trigger: 'blur' }
        ],
        link_man: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        link_phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入联系地址', trigger: 'blur' }
        ],
        copyright: [
          { required: true, message: '请输入版权所有', trigger: 'blur' }
        ],
      }
    }
  },
  created() {
    this.onGetWebSitInfo()
  },
  methods: {
    onGetWebSitInfo() {
      getWebSitInfo().then(res=> {
        this.webSitInfo = res.data.data['info']
      })
    },
    saveAction() {
      this.$refs['infoForm'].validate((valid) => {
        if (valid) {
          editWebSitInfo(this.webSitInfo).then(res=> {
            let { error, message } = res.data
            if (error === 200) {
              this.$Notice.success({
                title: '成功提示',
                desc: message
              })
              this.onGetWebSitInfo();
            }else {
              this.$Notice.error({
                title: '错误提示',
                desc: message
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
